module.exports = __webpack_public_path__ + "img/talk_to_expert_2.747a7a4e.svg";